var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3711 17.0703V18.2422C15.3711 18.8895 14.8465 19.4141 14.1992 19.4141H5.02852H3.46328C2.8125 19.4141 2.28516 18.8867 2.28516 18.2359V4.10781C2.28516 3.45703 2.8125 2.92969 3.46328 2.92969H4.62891",
    stroke: "#D2042D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7148 15.8984C17.7148 16.5457 17.1902 17.0703 16.543 17.0703H7.37227H5.80703C5.15637 17.0703 4.62891 16.5429 4.62891 15.8922V1.76406C4.62891 1.1134 5.15637 0.585938 5.80703 0.585938H12.672C12.987 0.585938 13.289 0.711406 13.5113 0.934648L17.3697 4.80965C17.5907 5.03164 17.7148 5.33211 17.7148 5.64539V10.2738V15.8984Z",
    stroke: "#D2042D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1641 0.695312V5.1582H17.6086",
    stroke: "#D2042D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24609 8.76562H15.0195",
    stroke: "#D2042D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0195 11.1094H12.3438",
    stroke: "#D2042D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.1094H7.24609",
    stroke: "#D2042D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24609 13.4531H15.0195",
    stroke: "#D2042D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc-icon.039b11640d9698e54b354254af0e3d99.svg";
export { ForwardRef as ReactComponent };